<template>
  <div class="feature-section">
    <div class="feature-list">
      <div class="feature-item" v-for="(item, index) in featureSectionList" :key="index">
        <div class="feature-icon">
          <img :src="item.icon" alt="" />
        </div>
        <h3 class="feature-title">{{ getItemTitle(item) }}</h3>
        <p class="feature-desc">{{ getItemDesc(item) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeatureSection',
  props: {
    featureSectionList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getItemTitle(item) {
      return item.titleKey ? this.$t(item.titleKey) : item.title
    },
    getItemDesc(item) {
      return item.descKey ? this.$t(item.descKey) : item.desc
    }
  }
}
</script>

<style scoped>
.feature-section {
  width: calc(100% - 40px);
  padding: 60px 20px;
  background: #ffffff;
}

.feature-list {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  flex: 1;
  max-width: 320px;
  text-align: center;
}

.feature-icon {
  margin: 0 auto 24px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon img {
  width: 100%;
  height: auto;
  display: block;
}

.feature-title {
  margin: 0 0 20px;
  font-size: 1.7vw;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
}

.feature-desc {
  margin: 0;
  font-size: 1.1vw;
  line-height: 1.8;
  color: #666;
  text-align: left;
}

@media (max-width: 992px) {
  .feature-list {
    flex-direction: column;
    align-items: center;
    gap: 48px;
  }
  .feature-item {
    max-width: 400px;
  }
  .feature-title {
    font-size: 24px;
  }
  .feature-desc {
    font-size: 16px;
  }
}
</style>